import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function GeneralSettings({ onClose, channels, pinnedChannels, inline }) {
  const [pinned, setPinned] = useState(pinnedChannels || []);

  const toggle = (ch) => {
    if (pinned.includes(ch)) {
      setPinned(pinned.filter(c => c !== ch));
    } else if (pinned.length < 5) {
      setPinned([...pinned, ch]);
    }
  };

  const handleSave = () => {
    const session = localStorage.getItem('session');
    if (session) {
      try {
        const part = session.split('.')[1];
        const padded = part + '='.repeat((4 - part.length % 4) % 4);
        const payload = JSON.parse(atob(padded.replace(/-/g,'+').replace(/_/g,'/')));
        fetch(`${API_BASE}/state/${payload.guild_id}`, {
          method: 'POST',
          headers: { 'Authorization': 'Bearer ' + session, 'Content-Type': 'application/json' },
          body: JSON.stringify({ action: 'set_pinned_channels', pinned_channels: pinned })
        });
      } catch(e) { console.error('Save failed:', e); }
    }
    onClose();
  };

  const body = (
    <>
      <h3 style={{ fontSize: '0.8rem', marginBottom: '8px', color: 'var(--text)' }}>Pinned Channels ({pinned.length}/5)</h3>
      <p style={{ fontSize: '0.65rem', color: 'var(--text-dim)', marginBottom: '12px' }}>Select up to 5 channels to show as quick-access pills on the console.</p>
      <div className="gs-channel-list">
        {(channels || []).map(ch => (
          <div key={ch} className={`gs-channel-item ${pinned.includes(ch) ? 'selected' : ''} ${!pinned.includes(ch) && pinned.length >= 5 ? 'disabled' : ''}`} onClick={() => toggle(ch)}>
            <span className="gs-check">{pinned.includes(ch) ? '✓' : ''}</span>
            <span># {ch}</span>
          </div>
        ))}
        {(!channels || channels.length === 0) && <p style={{ fontSize: '0.7rem', color: 'var(--text-dim)' }}>No channels synced. Restart the bot to sync.</p>}
      </div>
      <div style={{ marginTop: '12px' }}><button className="btn-primary" onClick={handleSave}>Save</button></div>
    </>
  );

  if (inline) return <div className="settings-inline">{body}</div>;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>⚙️ General Settings</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">{body}</div>
        <div className="modal-footer">
          <button className="btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}
